/**
 * @description Hook utilizado para manipular o exame de Identificação Balística
 * @author Diego Sabino Amorim de Araújo
 * @file useExameIdentificacaoBalisticaService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { setProcessando } from 'actions'
import { useFetch } from './useFetch'

export const useExameIdentificacaoBalisticaService = () => {
  const fetch = useFetch()

  const listarExameIdentificacaoAsync = async (idExameIdentificacao, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameIdentificacaoBalistica/${idExameIdentificacao}`)

      return response.data.exameIdentificacao
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }
  return {
    listarExameIdentificacaoAsync,
  }
}
